import { createAsyncThunk } from '@reduxjs/toolkit';

const onFetchKulaBlueprint = async ({ searchTerm }, { extra: { http } }) => {
  try {
    if (searchTerm) {
      const data = await http.get(`/blueprints/kula/search?q=${searchTerm}`);
      return data;
    }
    const data = await http.get('/blueprints/kula');
    return data;
  } catch (e) {}
};

const onFetchOrgBlueprint = async ({ searchTerm }, { extra: { http } }) => {
  try {
    if (searchTerm) {
      const data = await http.get(`/blueprints/org/search?q=${searchTerm}`);
      return data;
    }
    const data = await http.get('/blueprints/org');
    return data;
  } catch (e) {}
};

const onFetchBlueprintById = async ({ blueprint }, { extra: { http } }) => {
  try {
    const result = await http.get(`/blueprints/${blueprint?.id}`);
    return result?.data;
  } catch (e) {}
};

const onFetchBlueprintByIdInBg = async ({ blueprint }, { extra: { http } }) => {
  try {
    const result = await http.get(`/blueprints/${blueprint?.id}`);
    return result?.data;
  } catch (e) {}
};

export const fetchKulaBlueprint = createAsyncThunk(
  'blueprint/kula/list',
  onFetchKulaBlueprint
);

export const fetchOrgBlueprint = createAsyncThunk(
  'blueprint/org/list',
  onFetchOrgBlueprint
);

export const fetchBlueprintById = createAsyncThunk(
  'blueprint/kula/show',
  onFetchBlueprintById
);

export const fetchBlueprintByIdInBackground = createAsyncThunk(
  'blueprint/kula/show/bg',
  onFetchBlueprintByIdInBg
);
